<script>
import shareMixin from '@/mixins/shares'

export default {
	name: 'AppFooter',
	mixins: [shareMixin],
}
</script>


<template>
<footer>
	<div class="wrap">
		<div class="share clearfix">
			<a :href="shareFb" target="_blank" @click="shareClick('fb')"><i class="fa fa-facebook" aria-hidden="true"></i></a>
			<a :href="shareVk" target="_blank" @click="shareClick('vk')"><i class="fa fa-vk" aria-hidden="true"></i></a>
			<a :href="shareTg" target="_blank" @click="shareClick('tg')"><i class="fa fa-telegram" aria-hidden="true"></i></a>
			<a :href="shareTw" target="_blank" @click="shareClick('tw')"><i class="fa fa-twitter" aria-hidden="true"></i></a>
			<a :href="shareOk" target="_blank" @click="shareClick('ok')"><i class="fa fa-odnoklassniki" aria-hidden="true"></i></a>
		</div>
		<div class="devider"></div>
		<div class="legal1">
			<div>© 1999–2017 ООО «Компания Афиша»</div>
			<div>Все права защищены</div>
			<div>Для лиц старше 16 лет</div>
		</div>
		<img class="rating" src="../assets/rating.svg" />
		<div class="legal2">THE WALKING DEAD TM & © 2017 AMC Network Entertainment LLC. All Rights Reserved.</div>
	</div>
</footer>
</template>

<style lang="less" scoped>
@import "../styles/colors.less";

footer {
	width: 100%;
	height: 200px;
	background: #090909;
	display: block;
}

.wrap {
	width: 100%;
	max-width: 630px;
	margin: 0 auto;
}

.share {
	padding: 20px 0;
}

.share a {
	width: 20%;
	padding: 20px 0;
	text-align: center;
	font-size: 26px;
	float: left;
	color: #6b6b6b;
	opacity: 0.5;
	transition: opacity 200ms ease;
}

.share a:hover {
	opacity: 1;
}

.devider {
	width: 100%;
	height: 1px;
	background: #333333;
}

.legal1 {
	font-size: 13px;
	color: #a6a6a6;
	padding-top: 20px;
	display: flex;
	justify-content: space-between;
	position: relative;
}

.rating {
	width: 30px;
	margin: 25px auto;
	display: block;
}

.legal2 {
	text-align: center;
	font-size: 11px;
	color: #a6a6a6;
	padding-bottom: 50px;
}



@media only screen and (max-width: 650px) {

.legal1 {
	width: 90%;
	margin: 0 auto;
	display: block;
}

.legal1 div {
	width: 100%;
	text-align: center;
	padding-top: 10px;
}

}

</style>



// WEBPACK FOOTER //
// AppFooter.vue?229c6c08